import styled from "styled-components";
import name from "@images/logo2.png";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { device } from "@styles/theme";
import { useTranslation } from "react-i18next";
const Container = styled.div`
  display: grid;
  height: 100vh;
  position: relative;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  @media ${device.laptop} {
    height: auto;
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

const SignInPageLeftContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent linear-gradient(180deg, #e6ebf0 0%, #a8bace 100%) 0%
    0% no-repeat padding-box;
  @media ${device.tablet} {
    display: none;
  }
`;
const LeftImage = styled.img`
  height: 32.25rem;
  z-index: 100;
  @media ${device.laptop} {
    height: 10rem;
    margin: 3rem 0;
  }
`;

const SignInPageRightContainer = styled.div`
  flex-grow: 1;
  padding: 2.3rem;
  @media ${device.mobileL} {
    padding: 1.5rem;
  }

  /* width: 50%; */
`;
const SignInPageRightInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
const TopRightImageContainer = styled.div`
  display: flex;
  justify-content: end;
`;
const TopRightLogoImage = styled.img`
  width: 9.375rem;
  height: 3.25rem;
`;
const BottomRightLinkContainer = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 2.4rem;
`;
const SupportLink = styled(Link)`
  text-decoration: none;
  background: #355f44;
  height: 2.4rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: white;
  padding: 0.8rem 2.6rem;
  border-radius: 12px 12px 0px 12px;
  background: ${(props) => props.theme.colors.gray[600]};
`;
const AdminLoginLink = styled(SupportLink)`
  background: ${(props) => props.theme.colors.gray[500]};
`;
function BaseLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <Container>
      <SignInPageLeftContainer>
        <LeftImage src="/assets/login-page.png" />
      </SignInPageLeftContainer>
      <SignInPageRightContainer>
        <SignInPageRightInnerContainer>
          <TopRightImageContainer>
            <Link to="/">
              <TopRightLogoImage src={name} alt="named-logo" />
            </Link>
          </TopRightImageContainer>

          {children}
          <BottomRightLinkContainer>
            <SupportLink to="/support">{t("signin.trouble")}</SupportLink>
          </BottomRightLinkContainer>
        </SignInPageRightInnerContainer>
      </SignInPageRightContainer>
    </Container>
  );
}

export default BaseLayout;
